import React from 'react';
import { Box, BoxProps } from '@chakra-ui/react';
import { FC } from 'react';
import { WordBreakStyle } from '@investigator/shared/types';

export interface TruncatedTextProps extends Omit<BoxProps, 'sx'> {
  maxLines?: number;
  lineHeight?: string | number;
  wordBreak?: WordBreakStyle;
}

export const TruncatedText: FC<TruncatedTextProps> = ({
  children,
  maxLines = 1,
  lineHeight = '1.5',
  wordBreak = WordBreakStyle.BreakWord,
  ...rest
}): JSX.Element => {
  const isMultiline = maxLines > 1;
  return (
    <Box
      as="span"
      data-testid="truncated-text"
      color="inherit"
      wordBreak={wordBreak}
      lineHeight={lineHeight}
      {...(isMultiline
        ? {
            display: '-webkit-box',
            sx: {
              WebkitLineClamp: maxLines,
              WebkitBoxOrient: 'vertical',
              display: '-webkit-box',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              wordBreak: wordBreak,
              lineHeight: lineHeight,
            },
          }
        : {
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          })}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default TruncatedText;
